import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"
import Image from "gatsby-image"

const Layout = ({ location, title, logo, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  let header


  if (location.pathname === rootPath) {
    console.log( 'PRINITING LOVO', logo );
    header = (
      <div style={{clear: 'both'}}>
        <img src="/img/io-black.png" style={{float: 'left', width: 100, marginLeft: -22, marginTop: -14, marginBottom: 0}} />
        <h1
          style={{
            ...scale(1.5),
            marginBottom: rhythm(1.5),
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              background: 'linear-gradient(90deg, #000, #999)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h1>
      </div>
    )
  } else {
    header = (
      <h3
        style={{
          fontFamily: `Montserrat, sans-serif`,
          marginTop: 0,
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
            background: 'linear-gradient(90deg, #000, #999)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
          to={`/`}
        >
          <img src="/img/io-black.png" style={{ float: 'left', width: 52, marginLeft: -11, marginTop: -14, marginBottom: 0 }} />
          {title}
        </Link>
      </h3>
    )
  }
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(24),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
      }}
    >
      <header>{header}</header>
      <main>{children}</main>
      <footer style={{ borderTop: '1px solid #eee', paddingTop: 30, fontSize: '.8em', textAlign: 'right'}}>
        © javiio {new Date().getFullYear()}, built with
        {` `}
        <a href="https://www.gatsbyjs.org">Gatsby</a>
      </footer>
    </div>
  )
}

export default Layout
